/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './dismissMatch.defs.js'
export * as $defs from './dismissMatch.defs.js'
